module.exports = __webpack_public_path__ + "bf3.no1.90ef628f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bf3.no1.jpg
// module id = +IGX
// module chunks = 0